<script>
import { BToaster } from "bootstrap-vue";

export default {
  extends: BToaster
};
</script>